(function () {
	"use strict";

	function SortView() {
		this.View_constructor();

		this.build();
	}

	var p = createjs.extend(SortView, cm.View);

	p.build = function ()
	{
		this.width = cm.app.display.width * 0.5;
		this.height = cm.app.display.height * 0.5;
		cm.main.currentManifest = "Sort";
		this.background = new cjs.Bitmap(cm.Assets.lib["sortBackgroundLevel"+cm.main.selectedPlanetNum]).center();
		this.cannonWall = new cjs.Sprite(cm.Assets.lib.miscSS, "cannon-wall").set({x:-638, y: 41, mouseEnabled: false}).center();
		this.binArray = [];
		this.lidArray = [];
		this.popUpLabelArray = [];
		this.obstacleBox1 = null;
		this.obstacleBox2 = null;
		this.manifest = [];
		this.starNum = 0;
		this.levelSettings = cm.app.config.settings;
		this.levelMultiplier = this.levelSettings.levels[cm.main.selectedPlanetNum-1].multiplier;
		this.maxScore = this.levelMultiplier * (3 + cm.main.gameSettings.grapple);
		this.latestScore = cm.main.score;
		this.scoreMultiplier = 0;
		this.shotsFired = 0;
		this.cannonContainer = new cjs.Container().set({ mouseEnabled: false });
		this.cannonContBack = new cjs.Container().set({ mouseEnabled: false });
		this.pixelMove = 430 / (this.levelMultiplier*(3+cm.main.gameSettings.grapple));
		this.recycleObjects = cm.main.garbageCollected;
		this.objectOptions = cm.app.config.objects;
		if(this.recycleObjects.length < 5){
			this.addToSortingArray();
		}

		this.roundNum = 1;
		this.reuseOptions = [];
		this.garbageObjects = [];
		this.garbageSort = null;
		this.selectedBin = null;
		this.scoreSprite = null;
		this.isShoot = false;
		this.isSorted = false;
		this.roundOver = false;
		this.skipPressed = false;
		this.keysUsed = false;
		this.binsAreEnabled = false;
		this.starPopUpCalled = false;
		this.engine = null;
		this.projectile = null;
		this.sortNum = 0;
		this.labelPopUpContainer = new cjs.Container();
		this.binContainer = new cjs.Container();
		this.pointImage = null;
		this.wall = new cjs.Sprite(cm.Assets.lib.miscSS, "wall-sort").set({x:660, y:42}).center().set({ mouseEnabled: false });
		this.cannonImage = null;
		this.arrowContainer = new cjs.Container().set({ mouseEnabled: false });
		this.arrows = null;
		cm.app.music = null;
		this.mouseX = this.width;
		this.mouseY = this.height;
		this.callArrow = false;

		this.keyNav = new cm.KeyBoardNav();
		this.keyNav.navArrow = this.navArrow = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-home-btn").set({visible:false}).center();

		this.addChild(this.background, this.cannonContBack, this.cannonWall, this.labelPopUpContainer, this.binContainer, this.cannonContainer, this.arrowContainer, this.wall);
		this.lableMask();
		this.addUI();
		this.addBins();
		this.addSortableItems();
		this.addCannon();
		this.createBackGroundShape();
		this.arrows = new cm.Arrow();

		this.introBinNum = 0;
		this.introDone = false;

		if(cm.main.gameSettings.level1.challenge === 1){
			if(cm.Device.mobile && cjs.Touch.isSupported()){
				app.voPlayer.play([2000, "vo-7"], this.introIsFinished.bind(this));
			}
			else{
				app.voPlayer.play([2000, "vo-7", "vo-187"], this.introIsFinished.bind(this));
			}
		} else {
				var soundNameVO = this.objectOptions[this.garbageSort.name].soundName;
				app.voPlayer.play([2000, "vo-7-alt-3", "vo-82a", soundNameVO, "vo-82b"]);
				this.introDone = true;
				this.sharedUI.mouseEnabled = true;
			}
	};

	p.introIsFinished = function()
	{
		this.introDone = true;
		this.enableBins();
		var soundNameVO = this.objectOptions[this.garbageSort.name].soundName;
		app.voPlayer.play(["vo-82a", soundNameVO, "vo-82b", "vo-7-alt-3"], this.tutorialHandIntro.bind(this));
		this.sharedUI.mouseEnabled = true;
	};

	p.introBins = function()
	{
		if(this.introBinNum >3){
			var soundNameVO = this.objectOptions[this.garbageSort.name].soundName;
			if(this.introDone)
				app.voPlayer.play(["vo-82a", soundNameVO, "vo-82b", "vo-7-alt-3"]);

			this.sharedUI.mouseEnabled = true;
			return;
		}
		var bin = this.binArray[this.introBinNum];
		var voLines;
		voLines = ["vo-11", "vo-10", "vo-8", "vo-9"];


		bin.gotoAndPlay("bin-glow");
		bin.center();
		this.playIntroBinVo(voLines[this.introBinNum]);
	};

	p.tapLabelVo = function()
	{
		cjs.Tween.get(this.tutHand)
		.wait(2000)
		.to({alpha:1}, 150)
		.to({scaleX:0.8, scaleY:0.8}, 250)
		.to({scaleX:1, scaleY:1}, 250)
		.to({scaleX:0.8, scaleY:0.8}, 250)
		.to({scaleX:1, scaleY:1}, 250)
		.to({alpha:0}, 150);
	};

	p.tapBinVo = function()
	{
		cjs.Tween.get(this.tutHand)
		.set({x:350, y:-80})
		.wait(500)
		.to({alpha:1}, 150)
		.to({scaleX:0.8, scaleY:0.8}, 250)
		.to({scaleX:1, scaleY:1}, 250)
		.to({scaleX:0.8, scaleY:0.8}, 250)
		.to({scaleX:1, scaleY:1}, 250)
		.to({alpha:0}, 150);
		app.voPlayer.play("vo-178");
	};

	p.setTutHandInvisible = function()
	{
		if(this.tutHand){
			cjs.Tween.get(this.tutHand, {override: true})
			.to({alpha:0}, 100)
			.set({visible: false});
		}
	};

	p.tutorialHandIntro = function()
	{
		this.tutHand = new cjs.Sprite(cm.Assets.lib.gameSS, "tut-hand").set({alpha:0, x:210, y:-80}).center();
		this.addChild(this.tutHand);
		this.tapLabelVo();
		app.voPlayer.play(["vo-179", 500], this.tapBinVo.bind(this));
	};

	p.playIntroBinVo = function(vo)
	{
		app.voPlayer.play(vo, this.turnOffBinGlow.bind(this));
	};

	p.turnOffBinGlow = function()
	{
		var bin = this.binArray[this.introBinNum];
		bin.gotoAndPlay("bin");
		bin.center();
		this.introBinNum++;
		this.introBins();
	};

	p.addSortableItems = function ()
	{
		for (var i = 0, l = this.recycleObjects.length; i < l; i++) {
			var item = this.recycleObjects[i];
			var op = this.objectOptions[item];
			var garbage = new cjs.Sprite(cm.Assets.lib.junkSS, item).set({ name: item }).center();
			garbage.option1 = op.bestOption;
			garbage.option2 = op.secondOption;
			garbage.option3 = op.thirdOption;
			if(op.secondOption2){
				garbage.option2a = op.secondOption2;
			}
			if(i<5){
				this.preloadSounds(item);
			}
			garbage.scales = op.scale;
			this.garbageObjects.push(garbage);
		}
		cm.Assets.load(this.manifest, this.unloadCollection.bind(this));
		this.garbageObjects.shuffle();
		this.setupSort();


	};

	p.addToSortingArray = function()
	{
		var collectionArray = ["apple", "bagel", "banana", "cap", "cheese", "chips", "clock", "coffee-can", "coffee-flitter", "cord", "crayon-red", "crayon-yellow", "cup", "doll", "egg", "glass-bottle", "jar", "long-box", "magazine", "milk", "orange-bottle", "orange", "phone", "pizza", "plastic-bag", "shampoo-bottle", "shoes", "six-pack-rings", "soda", "stake", "stoll", "straw", "styrofoam-container", "tea-bag", "water-bottle", "dead-flower-1", "stack-food", "stack-ball", "tire", "stack-brick", "newspaper", "hat-1", "balloon"];
		var newArray = collectionArray, i, l;
		collectionArray.shuffle();
		for (i = 0, l = this.recycleObjects.length; i < l; i++) {
			var object = this.recycleObjects.length[i];
			newArray = this.checkObject(object, collectionArray);

		}
		for (i = 0, l = 5; i < l; i++) {
			var item = newArray[i];

			this.recycleObjects.push(item);
		}
	};

	p.unloadCollection = function()
	{
		console.log("unload assests");
		cm.Assets.unload("Collection");
	};

	p.preloadSounds = function(name) {
		var objectLoad = {"id": this.objectOptions[name].soundName, "src": "assets/audio/vo/"+this.objectOptions[name].soundName+".mp3"};
		this.manifest.push(objectLoad);
	};

	p.checkObject = function(object, array){
		var isInArray = false;
		var indexNum = 0;
		for (var i = 0, l = array.length; i < l; i++) {
			var element = array[i];
			if (object === element) {
				isInArray = true;
				indexNum = i;
			}
		}
		if (isInArray) {
			array.splice(indexNum, 1);
		}
		return array;
	};

	p.lableMask = function()
	{
		var m = new cjs.Graphics();
		m.f("#fff").r(0,0, 440, 500);
		var maskFillShape = new cjs.Shape(m);
		maskFillShape.set({x:-62, y:-216});
		this.labelPopUpContainer.mask = maskFillShape;
	};

	p.handleScore = function ()
	{
		//30px
		var testScore = cm.main.score + this.scoreMultiplier;
		var movePixel;
		var scoreDiffX = 0;

		if(this.maxScore < testScore){
			var diff = testScore - this.maxScore;
			var multiDiff = this.scoreMultiplier -diff;
			movePixel = this.pixelMove * multiDiff;

		}else{
			movePixel = this.pixelMove * this.scoreMultiplier;
		}

		if(this.scoreCursorContainer.x +movePixel > 215)
			scoreDiffX = 214 - (this.scoreCursorContainer.x + movePixel);

		if(this.maxScore > cm.main.score){
			cjs.Tween.get(this.scoreCursorContainer).to({ x: this.scoreCursorContainer.x + movePixel + scoreDiffX}, 150);
			cjs.Tween.get(this.maskFillShape).to({ x: this.maskFillShape.x + movePixel }, 150);

		}

		cm.main.score += 1 * this.scoreMultiplier;
		this.scoreCursorText.text = cm.main.score;
		this.scoreCursorText.center();
		this.scoreMultiplier = 0;

	};
	p.madeBinShot = function()
	{
		if(this.engine){
			if(this.obstacleBox1)
				this.obstacleBox1.kill();
			if(this.obstacleBox2)
				this.obstacleBox2.kill();

			this.engine.removeAllEntities();
		}

		cjs.Tween.get(this.cannonContainer).to({ rotation: 0 }, 200);
		cjs.Tween.get(this.cannonContBack).to({ rotation: 0 }, 200);
		this.isSorted = false;
	};

	p.checkEndLevel = function ()
	{
		this.sharedUI.mouseEnabled = true;
		if (this.roundNum === 5) {
			this.popUpEndGame();
			this.roundOver = true;
			this.removeChild(this.garbageSort);
			this.resetBins();
			this.isShoot = true;

		} else {

			this.removeChild(this.garbageSort);
			this.roundNum++;
			this.setupSort();
			this.resetBins();
		}
	};
	p.createBackGroundShape = function()
	{
		var bgGraphic = new cjs.Graphics();
		bgGraphic.f("#000").r(0,0,cm.app.display.width, cm.app.display.height);
		this.backGroundShape = new cjs.Shape(bgGraphic);
		this.backGroundShape.regX = cm.app.display.width * 0.5;
		this.backGroundShape.regY = cm.app.display.height * 0.5;
		this.backGroundShape.alpha = 0.4;
		this.backGroundShape.on("mousedown", function(){});
		this.backGroundShape.visible = false;
		this.addChild(this.backGroundShape);

	};

	p.popUpEndGame = function ()
	{
		this.popUpContainer = new cjs.Container();
		this.replayBtnContainer = new cjs.Container().set({ mouseChildren: false });
		this.homeBtnContainer = new cjs.Container().set({ mouseChildren: false });
		this.textPopUpContainer = new cjs.Container();
		var starContainer = new cjs.Container();
		this.backGroundShape.visible = true;
		var sortpopup, i,l,star;
		var xPos = 36;
		if (cm.main.gameSettings.grapple > 1) {
			sortpopup = new cjs.Sprite(cm.Assets.lib.gameSS, "upgrade-pop-up").center();
			var starNumLength = cm.main.gameSettings.grapple === 2 ? 4 : 5;

			var collectedWidth = 0;
			for (i = 0, l = starNumLength; i < l; i++) {
				star = new cjs.Sprite(cm.Assets.lib.gameSS, "upgrade-star-empty").set({ name: "upgrade-star-empty" }).center();
				star.x = xPos;
				star.y = 37;
				collectedWidth = star.regX + 36;
				// star.regX = 0;
				xPos += 80;
				starContainer.addChild(star);
			}
			starContainer.regX = ((collectedWidth) * i) * 0.5;
			starContainer.x = 0;
			starContainer.y = 25;
		} else {
			sortpopup = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-pop-up").center();
		}
		this.popUpContainer.y = 1500;

		var levelTextBG = this.addText("Level "+cm.main.selectedPlanetNum+" Complete", 40, "#003399").set({x: 9, y:-85, outline:3, mouseEnabled: false});
		var levelText = this.addText("Level "+cm.main.selectedPlanetNum+" Complete", 40, "#fff").set({x: 9, y:-85, mouseEnabled: false});
		this.textPopUpContainer.addChild(levelTextBG, levelText);

		var replaybg = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-replay-bg").set({name:"sort-replay-bg"}).center();
		var replaybtn = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-replay-btn").center();
		this.replayBtnContainer.on("click", this.buttonHandler, this);
		this.replayBtnContainer.on("mouseover", this.handleMouseOver, this);
		this.replayBtnContainer.on("mouseout", this.handleMouseOver, this);
		this.replayBtnContainer.addChild(replaybg, replaybtn);
		this.replayBtnContainer.set({x:-166, y: 172});
		this.replayBtnContainer.name = "replay-btn";
		this.replayBtnContainer.placeArrow = "up";
		this.replayBtnContainer.mouseEnabled = false;


		var homebg = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-replay-bg").set({name:"sort-home-bg"}).center();
		var homebtn = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-home-btn").center();
		this.homeBtnContainer.on("click", this.buttonHandler, this);
		this.homeBtnContainer.on("mouseover", this.handleMouseOver, this);
		this.homeBtnContainer.on("mouseout", this.handleMouseOver, this);
		this.homeBtnContainer.addChild(homebg, homebtn);
		this.homeBtnContainer.set({x:176, y:172});
		this.homeBtnContainer.name = "home-btn";
		this.homeBtnContainer.placeArrow = "up";
		this.homeBtnContainer.mouseEnabled = false;

		this.keyNav.buttons.push(this.replayBtnContainer, this.homeBtnContainer);

		this.popUpContainer.addChild(sortpopup, starContainer, this.textPopUpContainer,  this.replayBtnContainer, this.homeBtnContainer, this.navArrow);

		if (cm.main.gameSettings.grapple > 1) {
			this.upgradedPopUp();
		} else{
			xPos = [-103, 4, 111];
			var popUpStarArray = [];
			for (i = 0, l = 3; i < l; i++) {
				star = new cjs.Sprite(cm.Assets.lib.gameSS, "sort-star").set({x:xPos[i], y: 68, scaleX:0, scaleY:0, alpha:0, mouseEnabled: false }).center();
				this.popUpContainer.addChild(star);
				popUpStarArray.push(star);
			}
			cjs.Tween.get(this.popUpContainer).to({ y: 0 }, 500, cjs.Ease.backOut).wait(1000).call(this.checkPopUpStars, [popUpStarArray, this.textPopUpContainer], this);
			this.addChild(this.popUpContainer);
			app.sound.play("star-bar-fill");
		}

	};
	p.handleMouseOver = function(e)
	{
		switch(e.target.name)
		{
			case "replay-btn":
				if(e.type === 'mouseover'){
					app.voPlayer.play("vo-165");
				}
			break;
			case "home-btn":
				if(e.type === 'mouseover'){
					app.voPlayer.play("vo-124");
				}

			break;
		}
		var scaleObj = e.target.getChildAt(1);
		if (e.type === "mouseover") {
			cjs.Tween.get(scaleObj).to({ scaleX: 1.1, scaleY: 1.1 }, 150);
		}

		if (e.type === "mouseout") {
			cjs.Tween.get(scaleObj).to({ scaleX: 1, scaleY: 1 }, 150);
		}
	};

	p.upgradedPopUp = function()
	{
		var starContainer = new cjs.Container();
		var starNumLength = cm.main.gameSettings.grapple === 2 ? 4 : 5;
		var collectedWidth = 0;
		var popUpStarArray = [];
		var xPos = 33;
			for (var i = 0, l = starNumLength; i < l; i++) {
				var star = new cjs.Sprite(cm.Assets.lib.gameSS, "upgrade-star").set({ name: "upgrade-star" }).center();
				star.x = xPos;
				star.y = 37;
				collectedWidth = star.regX + 36;
				star.scaleX = star.scaleY = 0;
				star.alpha = 0;
				xPos += 80;
				popUpStarArray.push(star);
				starContainer.addChild(star);
			}
			starContainer.regX = ((collectedWidth) * i) * 0.5;
			starContainer.x = 0;
			starContainer.y = 25;
			this.popUpContainer.addChild(starContainer);
			cjs.Tween.get(this.popUpContainer).to({ y: 0 }, 500, cjs.Ease.backOut).wait(1000).call(this.checkPopUpStars, [popUpStarArray, this.textPopUpContainer], this);
			this.addChild(this.popUpContainer);
	};

	p.checkPopUpStars = function(array, container)
	{
		container.visible = false;
		this.starPopUpCalled = true;
		var fuzz = new cjs.Sprite(cm.Assets.lib.gameSS, "zap-1").set({x:5, y:-87}).center();
		var check = new cjs.Sprite(cm.Assets.lib.gameSS, "check-mark").set({x:0, y:-87, visible: false}).center();
		this.popUpContainer.addChild(fuzz, check);
		var checkWait = 0;
		var voArray;
		var star1, star2, star3, star4, star5;
		if(cm.main.score < this.levelMultiplier){
			app.voPlayer.play("vo-16");
		}

		if(cm.main.score >= this.levelMultiplier){
			star1 = array[0];
			if(star1)
				cjs.Tween.get(star1).call(this.popUpStarSound, [0], this).to({scaleX:1, scaleY:1, alpha:1}, 500, cjs.Ease.backOut).call(this.starZap, [star1], this);
			checkWait = 500;
			this.starNum = 1;
		}

		if(cm.main.score >= this.levelMultiplier * 2){
			star2 = array[1];
			if(star2)
				cjs.Tween.get(star2).wait(500).call(this.popUpStarSound, [1], this).to({scaleX:1, scaleY:1, alpha:1}, 500, cjs.Ease.backOut).call(this.starZap, [star2], this);
			checkWait = 1000;
			this.starNum = 2;
		}

		if(cm.main.score >= this.levelMultiplier * 3){
			star3 = array[2];
			if(star3)
				cjs.Tween.get(star3).wait(1000).call(this.popUpStarSound, [2], this).to({scaleX:1, scaleY:1, alpha:1}, 500, cjs.Ease.backOut).call(this.starZap, [star3], this);
			checkWait = 1500;
			this.starNum = 3;
		}
		if(cm.main.score >= this.levelMultiplier * 4 && cm.main.gameSettings.grapple > 1){
			star4 = array[3];
			if(star4)
				cjs.Tween.get(star4).wait(1500).call(this.popUpStarSound, [3], this).to({scaleX:1, scaleY:1, alpha:1}, 500, cjs.Ease.backOut).call(this.starZap, [star4], this);
			checkWait = 2000;
			this.starNum = 4;
		}
		if(cm.main.score >= this.levelMultiplier * 5 && cm.main.gameSettings.grapple > 2){
			star5 = array[4];
			if(star5)
				cjs.Tween.get(star5).wait(2000).call(this.popUpStarSound, [4], this).to({scaleX:1, scaleY:1, alpha:1}, 500, cjs.Ease.backOut).call(this.starZap, [star5], this);
			checkWait = 2500;
			this.starNum = 5;
		}

		if(cm.main.gameSettings.grapple === 1){
			voArray = ["vo-21", "vo-22", "vo-23-alt", "vo-23-alt", "vo-23-alt"];
		}
		if(cm.main.gameSettings.grapple === 2){
			voArray = ["vo-21", "vo-22", "vo-22", "vo-23-alt", "vo-23-alt"];
		}
		if(cm.main.gameSettings.grapple === 3){
			voArray = ["vo-21", "vo-22", "vo-22", "vo-22", "vo-23-alt", "vo-23-alt"];
		}
		var soundToPlay;
		if(this.starNum>0){
			soundToPlay = voArray[this.starNum-1];
			if(soundToPlay){
				app.voPlayer.play(soundToPlay);
			}
		}

		cjs.Tween.get(check).wait(checkWait).set({visible: true});

		cjs.Tween.get(fuzz, {loop: true})
		.wait(100)
		.call(fuzz.gotoAndPlay, ["zap-2"], fuzz)
		.wait(100)
		.call(fuzz.gotoAndPlay, ["zap-3"], fuzz)
		.wait(100)
		.call(fuzz.gotoAndPlay, ["zap-4"], fuzz)
		.wait(100)
		.call(fuzz.gotoAndPlay, ["zap-1"], fuzz);
		this.playNoiseSfx();
		cjs.Tween.get(fuzz).wait(checkWait).call(this.stopNoiseSfx, null, this).set({visible: false});
		this.homeBtnContainer.mouseEnabled = true;
		this.replayBtnContainer.mouseEnabled = true;
	};

	p.playNoiseSfx = function()
	{
		this.fuzzSound = app.sound.play("claw-upgrade", -1);
	};

	p.stopNoiseSfx = function()
	{
		this.fuzzSound.stop();
	};

	p.popUpStarSound = function(num)
	{
		var starSound = ["1-star", "2-stars", "3-stars", "3-stars", "3-stars"];
		app.sound.play(starSound[num]);
	};

	p.starZap = function(star)
	{
		var ranRotation = Math.range(0,360);
		var zap = new cjs.Sprite(cm.Assets.lib.gameSS, "electricity").set({x: star.x-star.parent.regX, y: star.y, rotation: ranRotation, scaleX:0, scaleY:0}).center();
		this.popUpContainer.addChildAt(zap,4);
		cjs.Tween.get(zap).to({scaleX:2, scaleY:2, alpha:0}, 250);
	};

	p.buildObstacles = function ()
	{
		var yPos = [-110, 60, 170];
		yPos.shuffle();
		var xPos = [-100, 50, 100];
		xPos.shuffle();
		this.obstacleBox1 = this.engine.spawnEntity(cm.Obstacle, xPos[1], yPos[1], this, "sort-obstacle");
		if(cm.main.gameSettings.grapple>2)
			this.obstacleBox2 = this.engine.spawnEntity(cm.Obstacle, xPos[2], yPos[2], this, "sort-obstacle");
	};

	p.resetBins = function ()
	{
		for (var i = 0, l = this.binArray.length; i < l; i++) {
			var bin = this.binArray[i];
			bin.mouseEnabled = false;
			var lid = this.lidArray[i];
			cjs.Tween.get(lid).to({ alpha: 0 }, 200).set({ x: bin.x - 120 });
		}
	};

	p.setupSort = function ()
	{
		this.sortNum++;
		this.garbageSort = this.garbageObjects[this.roundNum-1];
		this.garbageSort.y = 1000;
		cjs.Tween.get(this.garbageSort).wait(3000).call(cm.app.sound.play, ["trash-populate"], cm.app.sound).to({y: 0}, 500, cjs.Ease.backOut).call(this.callPopUpLabel, ["summon"], this);
		this.addChildAt(this.garbageSort, 5);
	};


	p.addCannon = function ()
	{

		this.cannon = new cjs.Sprite(cm.Assets.lib.gameSS, "cannon-front");
		this.cannonBack = new cjs.Sprite(cm.Assets.lib.gameSS, "cannon-back");
		this.cannonContainer.set({ x: -475, y: 40, regX:0, regY: 77.5 });
		this.cannonContainer.addChild(this.cannon);
		this.cannonContBack.set({ x: -475, y: 40, regX:0, regY: 77.5 });
		this.cannonContBack.addChild(this.cannonBack);
	};

	p.addBins = function ()
	{
		var binArray = ["landfill", "compost", "reuse", "recycle"];
		var yPos = -167;
		for (var i = 0, l = 4; i < l; i++) {
			var bin = new cjs.Sprite(cm.Assets.lib.gameSS, "bin").set({ x: 423, y: yPos, indexNum: i, name:binArray[i], mouseEnabled: false, placeArrow: "right" }).center();
			var popUpLabel = new cjs.Sprite(cm.Assets.lib.gameSS, "info-label").set({ x: bin.x + 150, y: bin.y,  name:binArray[i]+"-label", voNum: i, placeArrow: "right", alpha:0.65 }).center();
			var label = new cjs.Sprite(cm.Assets.lib.gameSS, binArray[i]+"-bin").set({ x: bin.x, y: bin.y, mouseEnabled: false}).center();
			var lid = new cjs.Sprite(cm.Assets.lib.gameSS, "lid").set({ x: bin.x - 120, y: bin.y-2, alpha: 0, mouseEnabled: false }).center();
			bin.lableSprite = label;
			this.labelPopUpContainer.addChild(popUpLabel);
			this.binContainer.addChild(bin, label, lid);
			this.popUpLabelArray.push(popUpLabel);
			this.binArray.push(bin);
			this.lidArray.push(lid);
			popUpLabel.on("mousedown", this.handleLabel, this);
			bin.on("mousedown", this.handleBin, this);
			bin.on("mouseout", this.handleBin, this);
			bin.on("click", this.handleBin, this);
			bin.on("mouseover", this.handleBin, this);
			this.keyNav.buttons.push(popUpLabel, bin);
			yPos += 135;
		}
	};

	p.handleLabel = function(e)
	{
		if(cm.app.voPlayer.playing){return;}
		var voLines = ["vo-11", "vo-10", "vo-8", "vo-9"];

		cm.app.voPlayer.play(voLines[e.target.voNum]);
	};

	p.callPopUpLabel = function (string)
	{
		var i, l, label;
		if(string === "summon")
		{
			cm.app.sound.play("categories-populate");
			for (i = 0, l = this.popUpLabelArray.length; i < l; i++) {
			   label = this.popUpLabelArray[i];
			   label.visible = true;
			   cjs.Tween.get(label).to({x: 290}, 500, cjs.Ease.backOut);
			}
			cjs.Tween.get(this).wait(500).call(this.enableBins, null, this);
			if(this.introDone && !this.roundOver){
				var soundNameVO = this.objectOptions[this.garbageSort.name].soundName;
				if(this.roundNum > 1)
					app.voPlayer.play(["vo-82a", soundNameVO, "vo-82b"]);
			}
			this.resetBins();
		}

		if(string === "leave")
		{
			for (i = 0, l = this.popUpLabelArray.length; i < l; i++) {
				label = this.popUpLabelArray[i];
				cjs.Tween.get(label).to({x: 573}, 500, cjs.Ease.backIn).set({visible:false});
			 }
		}
	};

	p.binCorrect = function ()
	{
		var voSound = ["vo-13", "vo-14", "vo-15"];
		voSound.shuffle();
		this.correctBinVOHandle();

		var sfxBin = [
			"0-points",
			"1-point",
			"2-points",
			"3-points"
		];
		app.sound.play(sfxBin[this.scoreMultiplier]);
		this.binScored = true;
		if(this.scoreSprite !== "plus0"){
			this.pointImage = new cjs.Sprite(cm.Assets.lib.gameSS, this.scoreSprite).set({ x: 0, y: -100, alpha: 1 }).center();
			this.addChild(this.pointImage);
			// cjs.Tween.get(this.pointImage).to({y:-300, alpha: 0}, 1000).call(this.removeObject, [this.pointImage], this);
			cjs.Tween.get(this.pointImage).to({x: this.scoreCursorContainer.x, y: this.scoreCursorContainer.y}, 1000).call(this.handleScore, null, this).to({alpha:0},250).call(this.removeObject, [this.pointImage], this);
		}
		this.mouseX = this.width;
		this.mouseY = this.height;
		this.madeBinShot();
		this.removeCannonImage();
	};

	p.createParticleEmitter = function (px, py) {
        // Create the display object or an array of display objects we want as the particles

        var shapes = [
			new cjs.Sprite(cm.Assets.lib.gameSS, "particle").center()
        ];

        // Settings for the particle you want
        var particle = {
            shape: shapes,
            lifetime: { min: 1, max: 3 },
            speed: { min: 2, max: 4 },
            rotateSpeed: { min: 0, max: 0 },
            scale: { start: 1, end: 0.6 },
            opacity: { start: 1, end: 0 },
            force: { x: -3, y: 0 },
            gravity: { on: true, speed: 5 }
        };

        // Settings for the emitter
        var emitterSettings = {
            pos: { x: 0, y: 0 },
            particle: particle,
            count: 10,
            rate: 0,
            loop: false,
            burst: true,
            startOn: true
        };
        var particleEmitter = new cm.ParticleEmitter(emitterSettings);
		var sparkleContainer = new cjs.Container().set({ mouseEnabled: false });
		sparkleContainer.x = px;
		sparkleContainer.y = py;
		sparkleContainer.addChild(particleEmitter);
		this.binContainer.addChildAt(sparkleContainer, 0);

		cjs.Tween.get(this).wait(1000).call(this.removeContainer, [sparkleContainer], this);
    };

	p.removeContainer = function(cont)
	{
		this.removeChild(cont);
	};

	p.correctBinVOHandle = function()
	{
		this.handleBinVO(this.selectedBin);
	};

	p.removeCannonImage = function()
	{
		if(this.cannonImage){
			this.cannonImage.parent.removeChild(this.cannonImage);
			this.cannonImage = null;
		}
	};

	p.handleBinVO = function(bin)
	{

		var soundNameVO = this.objectOptions[this.garbageSort.name].soundName;
		this.sharedUI.mouseEnabled = false;
		if(this.scoreMultiplier === 3){
			var voArray = ["vo-best-bin", "vo-great-job"];
			voArray.shuffle();
			if(this.shotsFired > 4){
				app.voPlayer.play(["vo-194", voArray[0]], this.checkEndLevel.bind(this));
			} else{
				app.voPlayer.play(voArray[0], this.checkEndLevel.bind(this));
			}

		} else{
			var binVO = bin.name+"VO";
			var optionVO = this.objectOptions[this.garbageSort.name][binVO];
			if(this.scoreMultiplier>0){
				if(this.shotsFired > 4)
					app.voPlayer.play(["vo-194", optionVO[0], soundNameVO, optionVO[1]], this.checkEndLevel.bind(this));
				else
					app.voPlayer.play([optionVO[0], soundNameVO, optionVO[1]], this.checkEndLevel.bind(this));
			}
			else
			{
				if(this.shotsFired > 4)
					app.voPlayer.play(["vo-194", optionVO[0], soundNameVO, optionVO[1]], this.checkEndLevel.bind(this));
				else
					app.voPlayer.play([optionVO[0], soundNameVO, optionVO[1]], this.checkEndLevel.bind(this));
			}
		}

		this.shotsFired = 0;

	};

	p.handleBin = function (e)
	{
		if(!this.introDone){return;}
		if(e.type === "mouseover"){
			cjs.Tween.get(e.target.lableSprite).to({scaleX:1.1, scaleY: 1.1}, 150);
		}
		if(e.type === "mouseout"){
			cjs.Tween.get(e.target.lableSprite).to({scaleX:1, scaleY: 1}, 150);
		}
		if(e.type === "mousedown"){
			cjs.Tween.get(e.target.lableSprite).to({scaleX:0.9, scaleY: 0.9}, 150);
		}

		if(e.type === "click"){
			app.sound.play("bin-select");
			this.setTutHandInvisible();
			cjs.Tween.get(e.target.lableSprite).to({scaleX:1, scaleY: 1}, 150, cjs.Ease.backOut);
			cjs.Tween.get(e.target)
			.call(e.target.gotoAndPlay, ["bin-glow"], e.target)
			.set({regX: 82, regY: 79.5})
			.wait(500)
			.call(e.target.gotoAndPlay, ["bin"], e.target)
			.set({regX: 68.5, regY: 66.5});
			var option, multiplier;
			var goodBin = false;
			if (e.target.indexNum === this.garbageSort.option1) {
				option = this.garbageSort.option1;
				this.scoreSprite = "plus3";
				multiplier = 3;
				goodBin = true;
			} else if (e.target.indexNum === this.garbageSort.option2) {
				option = this.garbageSort.option2;
				this.scoreSprite = "plus2";
				multiplier = 2;
				goodBin = true;
			}else if(e.target.indexNum === this.garbageSort.option2a) {
				option = this.garbageSort.option2a;
				this.scoreSprite = "plus2";
				multiplier = 2;
				goodBin = true;
			}
			else if (e.target.indexNum === this.garbageSort.option3) {

				option = this.garbageSort.option3;
				this.scoreSprite = "plus1";
				multiplier = 1;
				goodBin = true;
			} else {
				// voSound =["vo-16", "vo-17", "vo-18"];
				this.scoreSprite = "plus0";
				multiplier = 0;
				goodBin = true;
				option = e.target.indexNum;
				// this.handleBinVO(e.target);
			}

			if(goodBin){
				this.selectedBin = e.target;
				this.callPopUpLabel("leave");
				cjs.Tween.get(this).wait(1000).call(this.handleLids, [option], this);
				this.scoreMultiplier = multiplier;
				this.disableBins();
			}
		}

	};

	p.removeObject = function(object)
	{
		object.parent.removeChild(object);
		object = null;
	};

	p.handleLids = function (num)
	{
		for (var i = 0, l = this.lidArray.length; i < l; i++) {
			var lid = this.lidArray[i];
			if (num !== i)
				cjs.Tween.get(lid).to({ alpha: 1 }, 250).call(cm.app.sound.play, ["bin-lids"], cm.app.sound).to({ x: 345 }, 200, cjs.Ease.backIn);
		}
		cjs.Tween.get(this).wait(250).call(this.sendToCannon, null, this);

	};
	p.enableBins = function()
	{
		this.binsAreEnabled = true;
		for (var i = 0, l = this.binArray.length; i < l; i++) {
			var bin = this.binArray[i];
			bin.mouseEnabled = true;
			if(this.introDone) {
				if (!cm.Device.iPad2) {
					bin.tween = new cjs.Tween.get(bin.parent, {loop:true}).to({x:bin.parent.x-20},500, cjs.Ease.quadOut).to({x:bin.parent.x}, 500, cjs.Ease.quadIn);
				}
			}
		}
	};

	p.disableBins = function()
	{
		this.binsAreEnabled = false;
		for (var i = 0, l = this.binArray.length; i < l; i++) {
			var bin = this.binArray[i];
			bin.mouseEnabled = false;
			bin.tween = new cjs.Tween.get(bin.parent, {override:true}).to({x:0},250, cjs.Ease.quadIn);
		}
	};

	p.removeBinListeners = function ()
	{
		for (var i = 0, l = this.binArray.length; i < l; i++) {
			var bin = this.binArray[i];
			bin.removeAllEventListeners();
		}
	};

	p.sendToCannon = function ()
	{
		cjs.Tween.get(this.garbageSort)
			.to({ scaleX: 1.1, scaleY: 1.1 }, 250)
			.to({x: this.cannonContainer.x+200, y: this.cannonContainer.y, scaleX:0, scaleY:0, rotation:360}, 500, cjs.Ease.backIn)
			.wait(500)
			.set({visible:false})
			.call(this.cannonActivate, null, this);
	};

	p.cannonActivate = function ()
	{
		cm.app.sound.play("load-gun");
		this.addCannonImage();
		this.buildWorld();
		this.isSorted = true;
		// if(cm.Device.mobile && cjs.Touch.isSupported()){
		// 	this.background.on("pressmove", this.angleCannon, this);
		// if (!cm.Device.mobile) {
			this._stageMoveEvent = cm.app.display.stage.on('stagemousemove', this.angleCannon, this);
			this._stageUpEvent = cm.app.display.stage.on('stagemouseup', this.arrowDeactivate, this);
		// }
		this.arrowActivate();
		// this.background.on("click", this.arrowDeactivate, this);

		if(cm.main.selectedPlanetNum === 1 && cm.main.gameSettings.level1.challenge === 1 && this.sortNum < 2){
			if(cm.Device.mobile && cjs.Touch.isSupported())
				cm.app.voPlayer.play("vo-12");
			else
				cm.app.voPlayer.play("vo-12-alt");
		}
	};

	p.addCannonImage = function()
	{
		this.cannonImage = new cjs.Sprite(cm.Assets.lib.junkSS, this.garbageSort.name).set({x: 69, y:74, scales: this.garbageSort.scales,  scaleX: 0, scaleY: 0}).center();
		this.cannonContainer.addChild(this.cannonImage);
		this.binScored = true;
		this.callCannonImageScale();
	};

	p.arrowActivate = function ()
	{
		if (this.isShoot || !this.isSorted) { return; }
		this.callArrow = true;
	};

	p.arrowDeactivate = function ()
	{
		if (this.isShoot || !this.isSorted || !this.callArrow) { return; }
		this.callArrow = false;
		this.arrowContainer.removeAllChildren();
			this.isShoot = true;
			this.shotsFired++;
			this.projectile = this.engine.spawnEntity(cm.Projectile, this.cannonContainer.x, this.cannonContainer.y, this, this.garbageSort.name);
			this.projectile.allowUserControl = true;
			cm.app.sound.play("gun-shoot");
			this.addChild(this.projectile);
			this.projectile.launchBall(100, Math.toRad(this.cannonContainer.rotation-180));

			if(this.cannonImage){
				this.cannonImage.visible = false;
				this.cannonImage.scaleX = this.cannonImage.scaleY = 0;
			}

	};

	p.angleCannon = function (event)
	{
		if (this.isShoot || !this.isSorted || !this.callArrow || cm.main.pause) { return; }
		var stage = cm.app.display.stage;
		this.keysUsed = false;
		this.mouseX = event.stageX;
		this.mouseY = event.stageY;
		var pt = this.globalToLocal(this.mouseX, this.mouseY);
		if(pt.x > this.cannonContainer.x){
			var ax = pt.x - this.cannonContainer.x;
			var ay = pt.y - this.cannonContainer.y;
			var theta = Math.atan2(ay, ax);
			theta *= 180 / Math.PI;
			if (theta < 0)
				theta = theta;

			this.cannonContBack.rotation = this.cannonContainer.rotation = Math.limit(theta, -65, 55);
		}
	};

	p.handleArrow = function (pt, cx, cy)
	{
		if (this.isShoot || !this.isSorted) { return; }

		this.arrowContainer.removeAllChildren();
		this.arrows.createArrows(this.cannonContainer.x, this.cannonContainer.y, this.arrowContainer);
		this.arrows.launchArrow( pt, cx, cy);
	};

	p.buildWorld = function ()
	{
		this.engine = new cm.Box2D();
		this.engine.createWorld(0, 0);
		this.engine.addContactListeners();

		if (cm.debug) {
			// this.engine.drawDebug(cm.main.debugLayer, cm.main.gameStage);
		}
		this.buildPhysicsScene();
	};

	p.buildPhysicsScene = function ()
	{
		///BORDER
		this.engine.createCeiling(0, cm.app.display.height / 2 - 67, cm.app.display.width, 20);
		this.engine.createGround(0, -cm.app.display.height / 2 + 140, cm.app.display.width, 20);

		///BIN PHYSICS
		var bin1 = this.engine.createGround(this.selectedBin.x - 5, this.selectedBin.y - 70, 155, 10);
		var bin2 = this.engine.createGround(this.selectedBin.x - 5, this.selectedBin.y + 70, 155, 10);

		for (var i = 0, l = this.lidArray.length; i < l; i++) {
			var lid = this.lidArray[i];
			if (lid.alpha > 0)
				this.engine.createWall(lid.x, lid.y, 40, 129);
		}
		if(cm.main.gameSettings.grapple>1)
			this.buildObstacles();

		this.binScored = false;


	};

	p.addUI = function ()
	{
		this.sharedUI = new cm.SharedUI("SortView");
		this.sharedUI.y = -100;
		this.sharedUI.mouseEnabled = false;

		this.addScoreBar();
		this.addChild(this.scoreBarContainer, this.sharedUI, this.navArrow);
		this.sharedUI.addButtonToKeyNav();
	};

	p.addScoreBar = function()
	{

		var posNum = this.pixelMove * cm.main.score;
		////SCOREBAR
		this.scoreBarContainer = new cjs.Container().set({ mouseEnabled: false });
		this.scorebar = new cjs.Sprite(cm.Assets.lib.gameSS, "score-bar").center();
		this.scorebar.y = -325;
		var frontCover = new cjs.Sprite(cm.Assets.lib.gameSS, "front-cover").set({x:7, y:-322}).center();

		this.uiPlanet = new cjs.Sprite(cm.Assets.lib.gameSS, "ui-level-"+cm.main.selectedPlanetNum).center();
		this.uiPlanet.x = 332;
		this.uiPlanet.y = -319;
		var planetTextShadow = this.addText("Level "+cm.main.selectedPlanetNum, 20, "#000").set({x:this.uiPlanet.x, y: this.uiPlanet.y+48, alpha:0.5}).center();
		this.planetText = this.addText("Level "+cm.main.selectedPlanetNum, 20, "#f9d735").set({x:this.uiPlanet.x, y: this.uiPlanet.y+45}).center();

		///SCORE CURSOR
		var scoreCursor = new cjs.Sprite(cm.Assets.lib.gameSS, "score-cursor").center();
		this.scoreCursorText = this.addText(cm.main.score, 25);
		this.scoreCursorText.y = 17;
		this.scoreCursorText.textBaseline = "middle";

		this.scoreCursorContainer = new cjs.Container();

		this.scoreCursorContainer.set({x:-208+posNum, y:-286});

		///FILL BAR SHAPE

		this.fillShape = new cjs.Sprite(cm.Assets.lib.gameSS, "fill-bar").set({x:6, y: -325, name: "fill-bar" }).center();

		//BAR SHAPE MASK

		var m = new cjs.Graphics();
		m.f("#fff").r(0,0, 440, 41);
		this.maskFillShape = new cjs.Shape(m);
		this.maskFillShape.set({x:-209 + posNum, y:-346, regX: 440});

		this.fillShape.mask = this.maskFillShape;

		this.scoreCursorContainer.addChild(scoreCursor, this.scoreCursorText);

		this.scoreBarContainer.addChild(this.scorebar, this.fillShape, frontCover, this.uiPlanet, planetTextShadow, this.planetText);
		var multiplier = this.levelMultiplier;
		var star, starText;
		for (var i = 0, l = 2+cm.main.gameSettings.grapple; i < l; i++) {
			star = new cjs.Sprite(cm.Assets.lib.gameSS, "score-star").set({x:-208+(this.pixelMove*multiplier), y:-326, name:"star"+i+1}).center();
			starText = this.addText(multiplier, 20, "#000").set({x:star.x, y:-312});
			starText.textBaseline = "middle";
			multiplier += this.levelMultiplier;
			this.scoreBarContainer.addChild(star, starText);
		}
		this.scoreBarContainer.addChild(this.scoreCursorContainer);
		this.scoreBarContainer.y = -4;
	};

	p.addText = function (string, font, color)
	{
		var text = new cjs.Text(string, font + "px riffic-bold", color).center();
		return text;
	};
	p.playGameMusic = function()
	{
		app.music = null;
		app.music = "flying-game";
		app.musicInstance.volume = cm.main.musicVolume;
	};

	p.start = function ()
	{
		cjs.Tween.get(this).wait(1000).call(this.playGameMusic, null, this);
		cjs.Tween.get(this.sharedUI).wait(2000).call(cm.app.sound.play, ["button-drop"], cm.app.sound).to({y: -9}, 250, cjs.Ease.quadOut);
	};

	p.animateIn = function ()
	{
		return 0;
	};

	p.animateOut = function ()
	{
		return this.View_animateOut();

	};

	p.buttonHandler = function (e)
	{
		var btn;
		if (e.type === "mouseover") {
			cjs.Tween.get(e.target.getChildAt(1)).to({ scaleX: 1.1, scaleY: 1.1 }, 150);
		}

		if (e.type === "mouseout") {
			cjs.Tween.get(e.target.getChildAt(1)).to({ scaleX: 1, scaleY: 1 }, 150);
		}

		if (e.type === "mousedown") {
			btn = e.target.getChildAt(1);
			cjs.Tween.get(btn).to({scaleX: 0.9, scaleY: 0.9}, 150).to({scaleX: 1, scaleY: 1}, 150, cjs.Ease.backOut).call(this.buttonSwitch, [e.target], this);
		}
		if (e.type === "click") {
			this.navArrow.visible = false;
			cm.app.sound.play("click-1");
			btn = e.target.getChildAt(1);
			cjs.Tween.get(btn).to({scaleX: 0.9, scaleY: 0.9}, 150).to({scaleX: 1, scaleY: 1}, 150, cjs.Ease.backOut).call(this.buttonSwitch, [e.target], this);
		}
	};

	p.buttonSwitch = function(button)
	{
		switch(button.name){
			case "skip-bg":
				this.skipRound();
			break;
			case "replay-btn":
				if(button.mouseEnabled){
					this.replayLevel();
					button.mouseEnabled = false;
					button.removeAllEventListeners();
				}
			break;
			case "home-btn":
				if(button.mouseEnabled){
					this.handleLevelFinishSettings();
					this.goToView();
					button.mouseEnabled = false;
					button.removeAllEventListeners();
				}
			break;
		}
	};

	p.handleLevelFinishSettings = function()
	{
		if(cm.main.gameSettings["level"+cm.main.selectedPlanetNum].challenge <= cm.main.gameSettings.grapple)
			cm.main.gameSettings["level"+cm.main.selectedPlanetNum].challenge = cm.main.gameSettings.grapple+1;

		if(this.starNum > cm.main.gameSettings["level"+cm.main.selectedPlanetNum].stars)
			cm.main.gameSettings["level"+cm.main.selectedPlanetNum].stars = this.starNum;
		cm.main.gameSettings.shipPos = cm.main.lastPos = cm.main.previousPos;
		this.resortCollection();
	};

	p.resortCollection = function()
	{
		for (var i = 0, l = cm.main.garbageCollected.length; i < l; i++) {
		   var item = cm.main.garbageToCollect.splice(0,1);
		   cm.main.garbageToCollect.push(item[0]);
		}
	};

	p.replayLevel = function()
	{
		cm.main.score = this.latestScore;
		cm.main.pause = false;
		cm.ViewControl.gotoView("SortView");
		cm.ViewControl.transitIn();
	};

	p.animateOut = function () {
		cm.ViewControl.transitIn();
		return 2000;
	};

	p.skipRound = function()
	{
		this.binCorrect();
		this.skipPressed = true;
	};

	p.goToView = function ()
	{
		cm.main.score = 0;
		cm.ViewControl.gotoView("SpaceView");
	};

	p.callCannonImageScale = function()
	{
		if(this.cannonImage)
			this.arrowActivate();
			cjs.Tween.get(this.cannonImage).to({scaleX:this.cannonImage.scales, scaleY:this.cannonImage.scales}, 250, cjs.Ease.backOut);
			if(!this.binScored){
				var voSound =["vo-16", "vo-17", "vo-18"];
				voSound.shuffle();
				app.voPlayer.play(voSound[0]);
			}

	};
	
	p.handleKeyPress = function()
	{
		if (cm.main.pause || this.isShoot || !this.isSorted || !this.callArrow) {
			if (cm.Keyboard.state("enterKey")) {
				if(this.homeBtnContainer && this.starPopUpCalled){
					this.handleLevelFinishSettings();
					this.goToView();
				}
			}
			return;
		}

		if(cm.Keyboard.state("upKey") || cm.Keyboard.state("downKey")){
			this.keysUsed = true;
		}

		if(cm.Keyboard.state("upKey")){
			this.cannonContBack.rotation = this.cannonContainer.rotation = Math.limit(this.cannonContainer.rotation-1, -65, 55);
			this.arrowContainer.removeAllChildren();
			this.arrows.createArrows(this.cannonContainer.x, this.cannonContainer.y, this.arrowContainer);
			this.arrows.keyPressLaunchArrow(this.cannonContainer.rotation);
		}

		if(cm.Keyboard.state("downKey")){
			this.cannonContBack.rotation = this.cannonContainer.rotation = Math.limit(this.cannonContainer.rotation+1, -65, 55);
			this.arrowContainer.removeAllChildren();
			this.arrows.createArrows(this.cannonContainer.x, this.cannonContainer.y, this.arrowContainer);
			this.arrows.keyPressLaunchArrow(this.cannonContainer.rotation);
		}
		if (cm.Keyboard.state("enterKey")) {
			if(this.homeBtnContainer){
				this.keyNavHandle("home-btn");
			}
			if(this.keyNav.navArrow.visible){return;}
			this.callArrow = false;
			this.arrowContainer.removeAllChildren();
			this.isShoot = true;
			this.shotsFired++;
			this.projectile = this.engine.spawnEntity(cm.Projectile, this.cannonContainer.x, this.cannonContainer.y, this, this.garbageSort.name);
			this.projectile.allowUserControl = true;
			cm.app.sound.play("gun-shoot");
			this.projectile.launchBall(100, Math.toRad(this.cannonContainer.rotation-180));
			this.addChild(this.projectile);
			if (this.cannonImage) {
				this.cannonImage.visible = false;
				this.cannonImage.scaleX = this.cannonImage.scaleY = 0;
			}
		}
		if(cm.Keyboard.state("space")){
			if(this.keyNav.navArrow.visible){return;}
			this.callArrow = false;
			this.arrowContainer.removeAllChildren();
			this.isShoot = true;
			this.shotsFired++;
			this.projectile = this.engine.spawnEntity(cm.Projectile, this.cannonContainer.x, this.cannonContainer.y, this, this.garbageSort.name);
			this.projectile.allowUserControl = true;
			cm.app.sound.play("gun-shoot");
			this.projectile.launchBall(100, Math.toRad(this.cannonContainer.rotation-180));
			this.addChild(this.projectile);
			if (this.cannonImage) {
				this.cannonImage.visible = false;
				this.cannonImage.scaleX = this.cannonImage.scaleY = 0;
			}
		}
	};

	p.handleKeyBin = function(bin)
	{
		if (cm.main.pause || !this.binsAreEnabled) { return; }
		cjs.Tween.get(bin.lableSprite).to({ scaleX: 1, scaleY: 1 }, 150, cjs.Ease.backOut);
		app.sound.play("bin-select");
		cjs.Tween.get(bin)
			.call(bin.gotoAndPlay, ["bin-glow"], bin)
			.set({ regX: 82, regY: 79.5 })
			.wait(500)
			.call(bin.gotoAndPlay, ["bin"], bin)
			.set({ regX: 68.5, regY: 66.5 });
		var option, multiplier;
		var goodBin = false;
		if (bin.indexNum === this.garbageSort.option1) {
			option = this.garbageSort.option1;
			this.scoreSprite = "plus3";
			multiplier = 3;
			goodBin = true;
		} else if (bin.indexNum === this.garbageSort.option2) {
			option = this.garbageSort.option2;
			this.scoreSprite = "plus2";
			multiplier = 2;
			goodBin = true;
		} else if (bin.indexNum === this.garbageSort.option3) {

			option = this.garbageSort.option3;
			this.scoreSprite = "plus1";
			multiplier = 1;
			goodBin = true;
		} else {
			this.scoreSprite = "plus0";
			multiplier = 0;
			goodBin = true;
			option = bin.indexNum;
		}

		if (goodBin) {
			cm.app.sound.play("correct-answer");
			this.selectedBin = bin;
			this.callPopUpLabel("leave");
			cjs.Tween.get(this).wait(1000).call(this.handleLids, [option], this);
			this.scoreMultiplier = multiplier;
			this.disableBins();
		}
	};

	p.keyNavHandle = function(button)
	{
		switch(button.name){
			case "landfill":
			case "compost":
			case "reuse":
			case "recycle":
				this.handleKeyBin(button);
			break;
			case "help-bg":
			case "pause-bg":
				this.sharedUI.handleClick(button.name);
			break;
			case "home-btn":
				if(this.starPopUpCalled){
					this.handleLevelFinishSettings();
					this.goToView();
				}
			break;
			case "replay-btn":
				this.replayLevel();
			break;
			case "landfill-label":
			case "compost-label":
			case "reuse-label":
			case "recycle-label":
				if(cm.app.voPlayer.playing){return;}
				var voLines = ["vo-11", "vo-10", "vo-8", "vo-9"];
				cm.app.voPlayer.play(voLines[button.voNum]);
			break;
		}
	};

	p.resize = function()
	{
		this.sharedUI.resize();
	};

	p.update = function ()
	{
		if (this.engine && !cm.main.pause) {
			this.engine.update();

			if(!cm.Device.mobile){
				this.handleKeyPress();
			}

			if (this.callArrow && !this.keysUsed) {
				var pt = this.globalToLocal(this.mouseX, this.mouseY);
				var ax = this.cannonContainer.x - pt.x;
				var ay = this.cannonContainer.y - pt.y;
				var theta = Math.atan2(ay, ax);
				var deg = Math.toDeg(theta);
				if (deg < 0)
					deg += 360;
				if (deg < 240 && deg > 120) {
					this.handleArrow(pt, this.cannonContainer.x, this.cannonContainer.y);
				}

			}
			if (this.projectile) {
				if (this.projectile.displayObject.x > this.selectedBin.x - 80 && this.projectile.displayObject.x < this.selectedBin.x + 80 && this.projectile.displayObject.y < this.selectedBin.y + 80 && this.projectile.displayObject.y > this.selectedBin.y - 80) {
					this.projectile.kill();
					this.projectile = null;
					this.binCorrect();
					if(this.scoreSprite !== "plus0")
						this.createParticleEmitter(this.selectedBin.x-80, this.selectedBin.y);
				}
			}
		}
		if(cm.Keyboard){
			this.keyNav.keyCheck();
			cm.Keyboard.clearPressed();
		}

	};
	
	p.setActive = function(bool) {
		if (!bool) {
			this.keyNav.removeEventsOnButtons();
		}
	};

	p.destroy = function ()
	{
		cm.app.display.stage.off("stagemousemove", this._stageMoveEvent);
		cm.app.display.stage.off("stagemouseup", this._stageUpEvent);
		this.View_destroy();
	};

	cm.View.SortView = cjs.promote(SortView, "View");
})();